import { Box, BoxProps } from "@mui/system";
import { useSpotlight } from "./hooks";

/**
 * MUI Box for project cards. Tracks the pointer to drive a light-sweep
 * highlight (`--anim-mx/--anim-my`) — intentionally **no 3D tilt/rotation**.
 * Extra props (sx, children, etc.) are forwarded to the Box.
 */
export default function SpotlightCard({
  className = "",
  ...rest
}: BoxProps) {
  const { ref, onPointerMove } = useSpotlight<HTMLDivElement>();

  return (
    <Box
      ref={ref}
      onPointerMove={onPointerMove}
      className={`anim-card ${className}`.trim()}
      {...rest}
    />
  );
}
